


<template>
  <div class="stack_client_r_set_A">
    
    
    <div class="box feed">
      <img src="https://amadiary.com/data/file/story/jula17406238001.png">
      <div class="gradient"></div>
      <div class="header"> <span><i class="ph-fill ph-megaphone"></i></span>  <span><i class="ph ph-dots-three"></i></span> </div>
      <div class="content"> <h2>3월 7일 VFT지점 개업식</h2> <p>많은 분들이 와주셔서 축하 해주시면 좋겠습니다.</p> </div>
    </div>

    
    <div class="stacks">
      <div class="stack counsel">
        <div class="header"> <h2>👀 고객 상담</h2> <button>상담 시작</button> </div>
        <div class="content"><h2>상담문의: 2건</h2> <span>상담중: 4건</span></div>
      </div>

      <div class="stack recent_counsel">
        <div class="header"> <h2>👀 최근상담 목록</h2> </div>
        <ul>
          <li v-for="(counsel, index) in recent_counsel" :key="index">
            <span>{{ counsel.date }}</span> <div class="profile"><img :src="counsel.thumb"/> <div class="content"><h2>{{counsel.name}}</h2> <span>{{ counsel.tags }}</span> </div> </div> <p> <span id="notice" v-if="counsel.alr > 0">{{ counsel.alr }}</span> <i class="ph ph-chats-circle"></i></p>
          </li>
        </ul>
      </div>
    </div>
    
    
    <div class="box waiting_cli">
      <div class="header"> <h2>📃 상담을 기다리는 고객</h2> <span>더보기 <i class="ph ph-caret-right"></i></span> </div>
      <ul>
        <li v-for="(client, index) in waiting_clients" :key="index">
          <div class="profile"><img :src="client.thumb"/> <p>{{ client.name }}</p> </div>
          <p>{{ client.for }}</p>
          <span>상담하기</span>
        </li>
      </ul>
    </div>


  </div>
</template>




<script>
export default {
  data() {
    return {
      recent_counsel: [
        {date:"5/11", name:"오애순", thumb:"https://i.namu.wiki/i/4IQ0fXaR-ghchySzn-YQftyi3rU58bAMRPV6LqWA5IYAJdNfLK5hV35SwFmK-iwsSekrq2Fb1cokWY0ZUMW8ZJkB1tiG3Z_dzh1l3VEYVspr4wHNtKj52TFEmfjd_g8KvWjdknra_PoSDrso-Pid2g.webp", tags:"#32세 #여성 #태아", alr:1},
        {date:"5/11", name:"양관식", thumb:"https://i.namu.wiki/i/NjR0C3fA2hj1Ripj5z01A-4BIYwD3jR0kKRDObHL5erF2f3qeWHw6mc5mHHLL_q2UI-RYHyhmXxnWDIeFw8UYPgK_FtIVwSWogOloYFH376DR5jfKvzIt4pJ60gxZZpe9E8XlVzpKH9i2Vdu6pEe3A.webp", tags:"#34세 #남성 #자동차", alr:0},
        {date:"5/11", name:"염병철", thumb:"https://i.namu.wiki/i/Ykafx6STvmkD61NLIc_n-cFyGriAJPraalt0lqGC5EVyPxDofDduUkTLCKUpzVvhij38pBWI5nssiitRYNUSx4IpVVX4cNvQOhWfCAkxRphTbdC4fmqtzKCboH-eDPjrlypMSMozLnItI6KxD_yzkw.webp", tags:"#53세 #남성 #종합보험", alr:0},
        {date:"5/11", name:"박영란", thumb:"https://i.namu.wiki/i/7_k3k1XGRAdpy7udxJcQR84zzm2EyrgozspsTS-zZXJuCH5Cu-S2O_PfdXGBDHWwvWg5RCWJIUi4NKiHudv4uV2qXBakVZvTqQP0_2_os0tsFPIyI0Fg3MQ_RIi_Gg0PdmWhxckh_Oy9kNaNsLKumw.webp", tags:"#77세 #여성 #암보험", alr:1},
      ],
      waiting_clients: [
        { name:"김곤", thumb:"https://i.namu.wiki/i/6MCjuNosUXwYRyGvIsirpBfH2uuToWKGg0ldnR7O5SvX267X3PZe6e4UedAi0juM9neG-eDoRqiVIx17PqUqAbTJ_KRo0_Z7C6mCWc1IVTBeXyeslFMQdT0wU-WO6T5oWKWRc7EBJj4hiT46yh88NQ.webp", for:"상담요청", },
        { name:"정예림", thumb:"https://i.namu.wiki/i/_12OiF0qzf2AzuF_qx-JlapZ33smqKHFzw7g2CQB56AuNEHVtA3ki02qFpn0A4_I7lDfe99ZACvz4KsaqCpZUV8zowklq9983dTTKt3Pv-QLv_kP_t6dyHXqMggyxhAyGP7QIsEY_y50kCtWz3ILBw.webp", for:"청구", },
        { name:"평은수", thumb:"https://i.namu.wiki/i/WJrG68ghzF7h0o_Fm737-CpSat5p75xSREFP9MEJIuJ_xILpn5fEiFMmvYVM2DkkbbN3QDEw6WOyEVTwCfdf6wi5d8r_Z8ml4tl82_O3VRGKKJV_-9hc1Z64RX7L1HLpMLXVzkDOfrQ7wvBGxg5lLA.webp", for:"문의", },
        { name:"고광렬", thumb:"https://i.namu.wiki/i/f9y7mhIkPvNNw5uwkLLkMD12BB-t3zMdV_qc5JUh4ckfBGWgOP--sdts7qfJllDb8RH9W5j7mc_GNzp_HWteeqSOYvGyuAB_gLOeJKClzMJKwbelOhqi6H1iM5iPQ9AyDDSGhfdmU1CyVtLAMpEqkA.webp", for:"이관", },
        { name:"곽철용", thumb:"https://cdn.entermedia.co.kr/news/photo/201910/10125_24729_1122.jpg", for:"선물요청", },
      ],
    }
  },
  methods: {
    clicked() {
    }
  }
}
</script>




<style scoped>

@media (max-width: 1280px) or (max-height: 800px) {
  .stack_client_r_set_A {
    height: 48vh !important;
  }

  .box {
    height:100% !important;
  }
}

@media (max-width: 1024px) or (max-height: 800px) {
  .stack_client_r_set_A {
    grid-template-columns: repeat(1, 1fr) !important;
    grid-template-rows : repeat(3, 1fr) !important;
    height:fit-content !important;
    padding:16px;
    box-sizing: border-box;
  }
}

.stack_client_r_set_A {
  width: 100%;
  height:auto;
  gap:24px;
  overflow:hidden;
  display:flex;
}

ul {
  list-style: none;
  padding:0;
  margin:0;
}

h2 {
  font-size: var(--font-size-md);
  font-weight: 600;
  padding:0;
  margin:0;
}

p {
  font-size: 14px;
  font-weight: 400;
  padding:0;
  margin:0;
}

.box {
  width:100%;
  height:auto;
  background: var(--color-surface);
  border-radius: var(--font-size-md);
  padding:var(--font-size-md);
  box-sizing: border-box;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  gap:12px;
  backdrop-filter: blur(24px);
  overflow:hidden;
  flex:1;
}

.header {
  width:100%;
  height:30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header > h2 {
  font-size: 20px;
  font-weight: 600;
  padding:0;
  margin:0;
}

.header > span {
  font-size: 14px;
  font-weight: 400;
  padding:0;
  margin:0;
  cursor: pointer;
}

.header > button {
  font-size: 14px;
  font-weight: 400;
  padding:0;
  margin:0;
  cursor: pointer;
  background: var(--color-brand);
  color: var(--color-text-primary);
  border-radius: 8px;
  border:none;
  padding:8px var(--font-size-md);
}

.stacks {
  width:100%;
  height:100%;
  display:flex;
  flex-direction: column;
  gap:24px;
  flex:1;
  overflow:hidden;
}

.stacks > .stack {
  width: 100%;
  height: 100%;
  flex:1;
  background: var(--color-surface);
  border-radius: var(--font-size-md);
  padding:var(--font-size-md);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: start;
  gap:12px;
  flex-direction: column;
  backdrop-filter: blur(24px);
}

.stacks > .stack:last-child {
  flex:2.5;
}

.stacks > .stack.counsel > .content {
  display:flex;
  width:100%;
  gap:var(--font-size-md);
}

.stacks > .stack.counsel > .content > h2 {
  font-size:20px;
  color:var(--color-brand);
}

.stacks > .stack.counsel > .content > span {
  font-size: var(--font-size-md);
  font-weight: 400;
  color: var(--color-text-primary);
  padding:0;
  margin:0;
}

.stacks > .stack.recent_counsel {
  width:100%;
  height:100%;
  display:flex;
  flex-direction: column;
  gap:24px;
}

.stacks > .stack.recent_counsel > ul {
  width:100%;
  height:100%;
  display:flex;
  flex-direction: column;
  gap:var(--font-size-md);
}

.stacks > .stack.recent_counsel > ul > li {
  width:100%;
  height:fit-content;
  display:flex;
  justify-content: space-between;
  align-items: center;
  border-radius: var(--font-size-md);
  gap:8px;
}

.stacks > .stack.recent_counsel > ul > li > span {
  font-size:12px;
}

.stacks > .stack.recent_counsel > ul > li > .profile {
  width:100%;
  height:fit-content;
  display:flex;
  justify-content: start;
  align-items: center;
  gap:6px;
}

.stacks > .stack.recent_counsel > ul > li > .profile > img {
  width:36px;
  height:36px;
  border-radius:50%;
  object-fit: cover;
}

.stacks > .stack.recent_counsel > ul > li > .profile > .content {
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap:6px;
}

.stacks > .stack.recent_counsel > ul > li > .profile > .content > h2 {
  font-size:var(--font-size-md);
  font-weight:600;
  color:var(--color-text-primary);
}

.stacks > .stack.recent_counsel > ul > li > .profile > .content > span {
  font-size:12px;
  font-weight:600;
  color:var(--color-text-primary);
}

.stacks > .stack.recent_counsel > ul > li > p {
  min-width:48px;
  height:36px;
  background: var(--color-surface);
  backdrop-filter: blur(24px);
  border-radius: 8px;
  display:flex;
  justify-content: center;
  align-items: center;
  font-size: var(--font-size-md);
  cursor: pointer;
}

.stacks > .stack.recent_counsel > ul > li > p > span#notice {
  position: absolute;
  right:-10px;
  top:-10px;
  width:24px;
  height:24px;
  background: var(--color-brand);
  border-radius:50%;
  display:flex;
  justify-content: center;
  align-items: center;
  font-size:12px;
}

.feed  {
  padding:0;
  cursor:pointer;
}

.feed > img {
  position: absolute;
  width:100%;
  height:100%;
  object-fit: cover;
}

.feed > .gradient {
  position: absolute;
  width:100%;
  height:100%;
  background: linear-gradient(0deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.0) 20%, rgba(0,0,0,0.0) 80%, rgba(0,0,0,0.6) 100%);
}

.feed > .header {
  left:0;
  top:0;
  position: absolute;
  width:100%;
  height:fit-content;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:var(--font-size-md);
  box-sizing: border-box;
}

.feed > .header > span {
  font-size: 24px;
  color: var(--color-text-primary);
  font-weight: 400;
  padding:0;
  margin:0;
  cursor: pointer;
}

.feed > .content {
  position: absolute;
  bottom:0;
  left:0;
  width:100%;
  height:fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  padding:var(--font-size-md);
  gap:6px;
  box-sizing: border-box;
}

.feed > .content > h2 {
  font-size: 20px;
  color: var(--color-text-primary);
  font-weight: 200;
  padding:0;
  margin:0;
}

.feed > .content > p {
  font-size: 14px;
  color: var(--color-text-primary);
  font-weight: 200;
  padding:0;
  margin:0;
}

.waiting_cli {
  gap:24px;
}

.waiting_cli > ul {
  width:100%;
  height:100%;
  display:flex;
  flex-direction: column;
  gap:12px;
}

.waiting_cli > ul > li {
  width:100%;
  height:36px;
  display:flex;
  justify-content: start;
  align-items: center;
  border-radius: var(--font-size-md);
  gap:8px;
}

.waiting_cli > ul > li > .profile {
  flex:1;
  width:100%;
  height:fit-content;
  display:flex;
  justify-content: start;
  align-items: center;
  gap:8px;
}

.waiting_cli > ul > li > .profile > img {
  width:36px;
  height:36px;
  border-radius:50%;
  object-fit: cover;
}

.waiting_cli > ul > li > .profile > p {
  font-size:14px;
  font-weight:600;
  color:var(--color-text-primary);
}

.waiting_cli > ul > li > p {
  flex:1;
  width:100%;
  font-size:14px;
  font-weight:400;
  color:var(--color-text-primary);
  display: flex;
  justify-content: center;
  align-items: center;
}

.waiting_cli > ul > li > span {
  width:100px;
  height:36px;
  background: var(--color-surface);
  backdrop-filter: blur(24px);
  border-radius: 8px;
  display:flex;
  justify-content: center;
  align-items: center;
  font-size:14px;
  font-weight:400;
  color:var(--color-text-primary);
  cursor:pointer;
}

</style>
